var _excluded = ["children", "m", "l", "xl", "xxl"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Grid } from '@mui/material';
import { jsx as ___EmotionJSX } from "@emotion/react";
var Column = function Column(_ref) {
  var children = _ref.children,
    m = _ref.m,
    l = _ref.l,
    xl = _ref.xl,
    xxl = _ref.xxl,
    rest = _objectWithoutProperties(_ref, _excluded);
  return ___EmotionJSX(Grid, _extends({
    item: true,
    xs: 12,
    sm: m || 6,
    md: l || m || true,
    lg: xl || l || m || true,
    xl: xxl || xl || l || m || true
  }, rest), children);
};
export default Column;